import { SubGenre } from "../../data/interface";

const electronicMusicSubgenres: Array<SubGenre> = [
  {
    name: "Downtempo",
    bpmRange: "60-90 BPM",
    description:
      "Downtempo is a subgenre characterized by relaxed and chilled-out rhythms. It often incorporates elements of ambient, trip-hop, and lounge music. Downtempo tracks usually have a slower tempo and create a laid-back atmosphere with soothing melodies, atmospheric textures, and downtempo beats. It is a genre perfect for unwinding and creating a relaxed ambiance.",
    artists: [
      {
        link: "https://open.spotify.com/artist/0cmWgDlu9CwTgxPhf403hb?si=7178679552a74c21",
        imgSrc: "https://www.clubbingspain.com/imagenes/Bonobo-2022.jpg",
        name: "Bonobo",
      },
      {
        link: "https://open.spotify.com/artist/5oOhM2DFWab8XhSdQiITry?si=cdd64122a3b7473f",
        imgSrc:
          "https://images.squarespace-cdn.com/content/v1/5cb099837046801bf8ed1e65/1580310259680-LJFFNTI3X0H48U1DDBL8/Tycho+-+Press+LA2020-Small.jpg?format=2500w",
        name: "Tycho",
      },
      {
        link: "https://open.spotify.com/artist/6HCnsY0Rxi3cg53xreoAIm?si=e764a65ebabc4122",
        imgSrc:
          "https://emancipatormusic.com/wp-content/uploads/2020/04/Doug_Solo_PrayerHands-uai-2400x2400.jpg?f3bdad",
        name: "Emancipator",
      },
      {
        link: "https://open.spotify.com/artist/25KNo5GDS6ZpLkjasaecA3?si=8f3733f63d774191",
        imgSrc:
          "https://scontent.faep14-2.fna.fbcdn.net/v/t1.6435-9/197515124_342162093937722_6336528052695792494_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=6ojgyQVP_JcAX9pUj3Y&_nc_ht=scontent.faep14-2.fna&oh=00_AfAu9mnHyotFqbyL0DXfDUUwDUa6qVspluKCs8OTmfWnng&oe=64BE80A9",
        name: "Thievery Corporation",
      },
      {
        link: "https://open.spotify.com/artist/14H7ag1wpQOsPPQJOD6Dqr?si=1221e44482e24402",
        imgSrc:
          "https://scontent.faep14-3.fna.fbcdn.net/v/t1.6435-9/124795155_216469133168042_1223693443162131723_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=tQqb-NBJj8IAX-PkHpj&_nc_ht=scontent.faep14-3.fna&oh=00_AfCqLthhiyOuc0DBEFIAWBy3AzSVOKlL5769UabUhSLGtg&oe=64BE73CB",
        name: "Zero 7",
      },
      {
        link: "https://open.spotify.com/artist/1O3ZOjqFLEnbpZexcRjocn?si=cbd8b239fc764c9a",
        imgSrc:
          "https://cdns-images.dzcdn.net/images/artist/726d4b9bc7c04a5e4b308fe8d2276dea/500x500.jpg",
        name: "RJD2",
      },
      {
        link: "https://open.spotify.com/artist/4tNxq9NGKTKaX8OkZBLgf0?si=N7sagc3XRBmGY3Pidd1ePA",
        imgSrc:
          "https://i1.sndcdn.com/artworks-jfeHJAEbjJi6LFMy-Gt79Vg-t500x500.jpg",
        name: "Nightmares on Wax",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/37i9dQZF1EIetaOvb0yaXt?utm_source=generator",
  },
  {
    name: "Trip-Hop",
    bpmRange: "80-110 BPM",
    description:
      "Trip-Hop is known for its slow, atmospheric beats combined with hip-hop influenced grooves. It often features dark and moody sounds, blending elements of electronic music, hip-hop, and downtempo. Trip-Hop tracks incorporate samples, deep basslines, and haunting vocals, creating a captivating and introspective sonic experience.",
    artists: [
      {
        link: "https://open.spotify.com/artist/6FXMGgJwohJLUSr5nVlf9X?si=64d8af5926914e62",
        imgSrc:
          "https://led.fm/images/led/content/Noticias/Espectaculos/Massive-Attack-8.jpg",
        name: "Massive Attack",
      },
      {
        link: "https://open.spotify.com/artist/6liAMWkVf5LH7YR9yfFy1Y?si=966c246e24644c80",
        imgSrc: "https://www.rockaxis.com/img/newsList/7997923.png",
        name: "Portishead",
      },
      {
        link: "https://open.spotify.com/artist/6hhA8TKRNryM8FNzqCqdDO?si=def2f7f6dddc4ea2",
        imgSrc:
          "https://images.squarespace-cdn.com/content/v1/5a0dd6831f318dcf5130a0d5/1587485376758-N4YX339FZTD3N0AWVBBV/Tricky-photos-005.jpg?format=1500w",
        name: "Tricky",
      },
      {
        link: "https://open.spotify.com/artist/6bWxFw65IEJzBYjx3SxUXd?si=cf38065af9e74fcb",
        imgSrc:
          "https://fabriziopedrotti.files.wordpress.com/2019/10/morcheeba2__.jpg?w=1612&h=1024&crop=1",
        name: "Morcheeba",
      },
      {
        link: "https://open.spotify.com/artist/5CE2IfdYZEQGIDsfiRm8SI?si=vp77NP8CSWuE0Snk-fe7_w",
        imgSrc:
          "https://i.discogs.com/nUM4uZES5D-emLU_vWnqUMFt-ZoKwg17toq8b5f2XXI/rs:fit/g:sm/q:90/h:455/w:367/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTQ0Nzgt/MTU4NDUzMTkxNy04/MjMwLmpwZWc.jpeg",
        name: "DJ Shadow",
      },
      {
        link: "https://open.spotify.com/artist/5EP020iZcwBqHRnJftibXX?si=f6997a121a6942cb",
        imgSrc:
          "https://images.sk-static.com/images/media/img/col6/20210310-103849-423786.jpg",
        name: "Hooverphonic",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/37i9dQZF1DWVXbA4kjkg6G?utm_source=generator",
  },

  {
    name: "Ambient",
    bpmRange: "90-120 BPM",
    description:
      "Ambient music focuses on creating an atmospheric and ethereal environment. It typically features slow and minimalistic beats, if any, and emphasizes textures, drones, and soothing melodies. Ambient music is often used for relaxation, meditation, or creating a calming atmosphere. It can range from serene and peaceful to mysterious and otherworldly.",
    artists: [
      {
        link: "https://open.spotify.com/artist/7MSUfLeTdDEoZiJPDSBXgi?si=5dfcc295a7554b54",
        imgSrc:
          "https://es.rollingstone.com/wp-content/uploads/2022/10/Brian-Eno-lanza-FOREVERANDEVERNOMORE-su-primer-album-desde-2017-1.jpg",
        name: "Brian Eno",
      },
      {
        link: "https://open.spotify.com/artist/36pCa1JHc6hlGbfEmLzJQc?si=6b6e9bcfdfc94aad",
        imgSrc:
          "https://i.discogs.com/rgbRwJLWfAz7M5TShYMtxjShy-3n3U4nfT-nOqQJgzY/rs:fit/g:sm/q:40/h:300/w:300/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTMzODYz/LTEzOTQzNzY2MDkt/NzQ2NS5qcGVn.jpeg",
        name: "Stars of the Lid",
      },
      {
        link: "https://open.spotify.com/artist/6kBDZFXuLrZgHnvmPu9NsG?si=7b9806a796ff43fb",
        imgSrc:
          "https://jenesaispop.com/wp-content/uploads/2023/02/aphex-twin-2.jpg",
        name: "Aphex Twin",
      },
      {
        link: "https://open.spotify.com/artist/3uOCouLFR4bVx0XeiQJSbl?si=3edc42fc46544eda",
        imgSrc:
          "https://www.latercera.com/resizer/XI0EbLE1pCrAZk6vZUaPH4wgVcg=/900x600/smart/cloudfront-us-east-1.images.arcpublishing.com/copesa/OQZOBFJJPFEO5D67LVOFQ2F33Q.jpg",
        name: "Harold Budd",
      },
      {
        link: "https://open.spotify.com/artist/00gh6kmKYOu8xyorRxQm6a?si=6d4bcc9b1db3494b",
        imgSrc:
          "https://i.discogs.com/IVfLbaMbcgsC_PkDNIRG9fBkxEZjhzJtgGZJi0HtulE/rs:fit/g:sm/q:90/h:864/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTEyOTc0/LTE2NDg4MjgyNDYt/MzA2OS5qcGVn.jpeg",
        name: "Steve Roach",
      },
      {
        link: "https://open.spotify.com/artist/1qiwaJwjKod5WhcYZ76O1B?si=6bb99fcb95d54de7",
        imgSrc:
          "https://i.guim.co.uk/img/media/d55869772e4d9651bd82465c404e0493020dac85/0_691_4125_2475/master/4125.jpg?width=1200&height=900&quality=85&auto=format&fit=crop&s=fe0eb89fa4aa9ed89051e45a3058efc4",
        name: "Tim Hecker",
      },
      {
        link: "https://open.spotify.com/artist/2rcnAZ6DvORQ365X3zVYpr?si=e95db3ed9d034eb7",
        imgSrc: "https://f4.bcbits.com/img/0017901006_10.jpg",
        name: "Biosphere",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/7rg9hm19AsS6ecb80tUPPX?utm_source=generator",
  },
  {
    name: "EDM",
    bpmRange: "100-160 BPM",
    description:
      "EDM (Electronic Dance Music) is a broad genre that encompasses various electronic music styles designed to ignite energy and excitement on the dance floor. It typically features catchy melodies, energetic beats, and a focus on creating an uplifting and euphoric atmosphere. EDM has gained immense popularity worldwide and has become a staple in festivals, clubs, and mainstream music charts.",
    artists: [
      {
        link: "https://open.spotify.com/artist/1vCWHaC5f2uS3yhpwWbIA6?si=0d6a96c94ce64d6b",
        imgSrc:
          "https://e00-marca.uecdn.es/assets/multimedia/imagenes/2021/12/30/16408557765641.jpg",
        name: "Avicii",
      },
      {
        link: "https://open.spotify.com/artist/7CajNmpbOovFoOoasH2HaY?si=91d5204e2d9a4a6b",
        imgSrc:
          "https://tn.com.ar/resizer/684z_nM3XC7DIPAsxs5_eE9lG6c=/767x0/smart/filters:format(webp)/cloudfront-us-east-1.images.arcpublishing.com/artear/IUJGCOMFJLSVATYSW43C2TEDHU.jpg",
        name: "Calvin Harris",
      },
      {
        link: "https://open.spotify.com/artist/60d24wfXkVzDSfLS6hyCjZ?si=8dd12bfa249a4718",
        imgSrc:
          "https://yt3.googleusercontent.com/in7ji16oeon_ypiAMeH-ZdTWSaIC54yZqMsFg0X3uhTBk4MDCuIkRf6TIoQQCqjl20DSdakhSQ=s900-c-k-c0x00ffffff-no-rj",
        name: "Martin Garrix",
      },
      {
        link: "https://open.spotify.com/artist/69GGBxA162lTqCwzJG5jLp?si=7100ad9a3d22405f",
        imgSrc: "https://okdiario.com/img/2019/11/12/the-chainsmokers.jpg",
        name: "The Chainsmokers",
      },
      {
        link: "https://open.spotify.com/artist/2qxJFvFYMEDqd7ui6kSAcq?si=9872a87565354140",
        imgSrc:
          "https://i.discogs.com/Xx33uhQDl-doCAKOCpUjmXep8zY3D4Pgy6uZgTEDRQ0/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTE5OTA1/NzEtMTYzNDY5NjUy/Mi03Mjg0LnBuZw.jpeg",
        name: "Zedd",
      },
      {
        link: "https://open.spotify.com/artist/1Cs0zKBU1kc0i8ypK3B9ai?si=a90627fcdd204993",
        imgSrc:
          "https://yt3.googleusercontent.com/ytc/AGIKgqPT9jSx9GKXHtHx-sSy1yoMidkBX5LabKlZDy_Y8A=s900-c-k-c0x00ffffff-no-rj",
        name: "David Guetta",
      },
      {
        link: "https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T?si=ceb9c48ab5464c93",
        imgSrc:
          "https://i.pinimg.com/736x/a6/a0/6c/a6a06c1740fc22e4520d43451e7f1c1b.jpg",
        name: "Marshmello",
      },
      {
        link: "https://open.spotify.com/artist/5he5w2lnU9x7JFhnwcekXX?si=dc4bb36b931d4364",
        imgSrc:
          "https://www.soundpark.news/__export/1620765317146/sites/debate/img/2021/05/11/skrillex-nueva-muxsica_crop1620765279613.png_554688468.png",
        name: "Skrillex",
      },
      {
        link: "https://open.spotify.com/artist/77AiFEVeAVj2ORpC85QVJs?si=a9ea7ff910c34e54",
        imgSrc:
          "https://taogroup.com/wp-content/uploads/2023/03/230000_TGH_Steve-Aoki_2400x2400.jpg",
        name: "Steve Aoki",
      },
      {
        link: "https://open.spotify.com/artist/2o5jDhtHVPhrJdv3cEQ99Z?si=d0107977c3dc4c7f",
        imgSrc:
          "https://s3.amazonaws.com/arc-wordpress-client-uploads/infobae-wp/wp-content/uploads/2019/03/25172503/Ti%C3%ABsto.jpg",
        name: "Tiësto",
      },
      {
        link: "https://open.spotify.com/artist/5fMUXHkw8R8eOP2RNVYEZX?si=8bdf2531406a4065",
        imgSrc:
          "https://resizer.glanacion.com/resizer/vTWWzxPXC3TnLYFCzLxjY60QeaA=/768x0/filters:format(webp):quality(80)/cloudfront-us-east-1.images.arcpublishing.com/lanacionar/DK3IWVZX3BAPND5VCDBKLIGG2I.jpg",
        name: "Diplo",
      },
      {
        link: "https://open.spotify.com/artist/7vk5e3vY1uw9plTHJAMwjN?si=902e98ee42714633",
        imgSrc:
          "https://yt3.googleusercontent.com/lK_4iP2d9hyh3XwAOh49H1iGJZXPhIkTNObrP0CcJI22wtDy_cthZqYW94FEnCQfzSRSf0y22Q=s900-c-k-c0x00ffffff-no-rj",
        name: "Alan Walker",
      },
      {
        link: "https://open.spotify.com/artist/4AVFqumd2ogHFlRbKIjp1t?si=cdfcd8ea733847ca",
        imgSrc: "https://www.clubbingspain.com/imagenes/Alesso_2015_600.jpg",
        name: "Alesso",
      },
      {
        link: "https://open.spotify.com/artist/6BrvowZBreEkXzJQMpL174?si=712696a0fb084f72",
        imgSrc:
          "https://cdns-images.dzcdn.net/images/artist/243a0ede39075f2251c3d18c4765bfed/500x500.jpg",
        name: "Hardwell",
      },
      {
        link: "https://open.spotify.com/artist/2XnBwblw31dfGnspMIwgWz?si=973fe98729a740fc",
        imgSrc:
          "https://yt3.googleusercontent.com/ytc/AGIKgqNCpEsANQaz0fID3s_I2q5m5VnXgAuy-gXhGURNdA=s900-c-k-c0x00ffffff-no-rj",
        name: "Axwell Λ Ingrosso",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/1lS6v9h4MXOw6f6y8MkS8w?si=d911ba0c4f124c8b",
  },
  {
    name: "Deep House",
    bpmRange: "120-125 BPM",
    description:
      "Deep House blends elements of house music with a slower and groovier feel. It features steady beats, deep basslines, and melodic elements. Deep House tracks often create a mellow and immersive experience, combining soulful vocals, jazzy chords, and smooth textures. The genre is well-suited for both relaxing and dancing.",
    artists: [
      {
        link: "https://open.spotify.com/artist/6nS5roXSAGhTGr34W6n7Et?si=2484063ab3724c2d",
        imgSrc:
          "https://www.billboard.com/wp-content/uploads/media/Disclosure-Simon-Emmett-bw-billboard-1548.jpg?w=1024",
        name: "Disclosure",
      },
      {
        link: "https://open.spotify.com/artist/27gtK7m9vYwCyJ04zz0kIb?si=cc623930d8a246b9",
        imgSrc:
          "https://i.scdn.co/image/ab6761610000e5eba63ca9a9ed590b0f7c9633a7",
        name: "Lane 8",
      },
      {
        link: "https://open.spotify.com/artist/6TshTCYwh9ySzOO6Jy4Ux2?si=423534e59f3b432a",
        imgSrc:
          "https://fmdelta903.com/images/Delta/Noticias/Maya-Jane-Coles-7.jpg",
        name: "Maya Jane Coles",
      },
      {
        link: "https://open.spotify.com/artist/2pfHsO54AOejDlJqtXnS85?si=932837c5f3aa47a5",
        imgSrc:
          "https://res.cloudinary.com/shotgun/image/upload/v1653986720/production/artworks/artists/Jimpster.jpg",
        name: "Jimpster",
      },
      {
        link: "https://open.spotify.com/artist/7nqpEU6DCHkNtK1bYsyS3W?si=adc0f00f23a7471e",
        imgSrc:
          "https://i1.sndcdn.com/avatars-wz10c5uYycpc8woY-gnHJQw-t500x500.jpg",
        name: "Kerri Chandler",
      },
      {
        link: "https://open.spotify.com/artist/5gqoUf9vKKv96b1c0GBKwu?si=6c1c333c0eb94783",
        imgSrc:
          "https://geo-media.beatport.com/image_size/590x404/7b39cd5e-9bdf-4b85-bec0-8ac50860383d.jpg",
        name: "Dusky",
      },
      {
        link: "https://open.spotify.com/artist/1tRBmMtER4fGrzrt8O9VpS?si=fa3017df7b3f431b",
        imgSrc:
          "https://dice-i-scdn-co.imgix.net/image/ab6761610000e5eb1d6a6362543fdc5cafeb7727",
        name: "Hot Since 82",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/6vDGVr652ztNWKZuHvsFvx?utm_source=generator",
  },

  {
    name: "Tech House",
    bpmRange: "120-130 BPM",
    description:
      "Tech House is a subgenre that blends elements of techno and house music. It features a slightly faster tempo than deep house, repetitive beats, and a focus on rhythm and percussions. Tech House tracks often incorporate catchy hooks, driving basslines, and groovy elements. It aims to create a dynamic and energetic atmosphere on the dancefloor.",
    artists: [
      {
        link: "https://open.spotify.com/artist/3ABaec4jjl95VqmG1iD4k2?si=70564e2821cc448c",
        imgSrc:
          "https://static.ra.co/images/profiles/lg/greenvelvet.jpg?dateUpdated=1644595304000",
        name: "Green Velvet",
      },
      {
        link: "https://open.spotify.com/artist/0oO1IaDOBSeI96HbnCa5pZ?si=a5e3c5896cf54ad9",
        imgSrc:
          "https://djmag.es/wp-content/uploads/2018/07/Solardo-5-tracks.jpg",
        name: "Solardo",
      },
      {
        link: "https://open.spotify.com/artist/1VJ0briNOlXRtJUAzoUJdt?si=98148067c1764e75",
        imgSrc: "https://taogroup.com/wp-content/uploads/2022/01/Fisher.jpg",
        name: "Fisher",
      },
      {
        link: "https://open.spotify.com/artist/7yRimuQSC5Ks3T2Ts0iyZa?si=f51e2ab26ade4ce6",
        imgSrc:
          "https://images.sk-static.com/images/media/profile_images/artists/7296559/huge_avatar",
        name: "Patrick Topping",
      },
      {
        link: "https://open.spotify.com/artist/240wlM8vDrf6S4zCyzGj2W?si=091dc578932c4807",
        imgSrc:
          "https://edm.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTg4MTMzMjgzMjc0NDM0MzQ2/camel-phat9750-2.jpg",
        name: "CamelPhat",
      },
      {
        link: "https://open.spotify.com/artist/4admDxmnri5Zco0xYrJ0ji?si=84b9b1d9470b46ae",
        imgSrc:
          "https://geo-media.beatport.com/image_size/590x404/320f4521-f2af-4cfa-b793-8941b68949be.jpg",
        name: "Jamie Jones",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/7nppx7uLgcmkZHg70HNfOk?utm_source=generator",
  },
  {
    name: "Progressive House",
    bpmRange: "125-130 BPM",
    description:
      "Progressive House is characterized by a steady and driving beat with gradually evolving melodies and textures. It often incorporates long builds and breakdowns, creating a sense of progression throughout the track. Progressive House tracks can be uplifting and euphoric, featuring lush melodies, atmospheric layers, and emotive elements.",
    artists: [
      {
        link: "https://open.spotify.com/artist/2CIMQHirSU0MQqyYHq0eOx?si=20301e025e3c47a3",
        imgSrc:
          "https://i.scdn.co/image/ab6761610000e5ebc5ceb05f152103b2b70d3b07",
        name: "Deadmau5",
      },
      {
        link: "https://open.spotify.com/artist/5sm0jQ1mq0dusiLtDJ2b4R?si=614c5e9416704bdb",
        imgSrc:
          "https://ege.electronicgroove.com/wp-content/uploads/2023/02/Eric-Prydz-1.jpg",
        name: "Eric Prydz",
      },
      {
        link: "https://open.spotify.com/artist/6u4jLGLPuarS3i2XWHVxoS?si=8b966ca07da447da",
        imgSrc:
          "https://imgproxy.ra.co/_/quality:66/aHR0cHM6Ly9zdGF0aWMucmEuY28vaW1hZ2VzL3Byb2ZpbGVzL3NxdWFyZS9zYXNoYS5qcGc_ZGF0ZVVwZGF0ZWQ9MTU0ODMwNTYyNjAwMA==",
        name: "Sasha",
      },
      {
        link: "https://open.spotify.com/artist/7Em4kWZ5atMYknHwSkp3gD?si=c6f064fea9c44f7a",
        imgSrc:
          "https://electronicgroove.com/wp-content/uploads/2017/03/Guy-J.jpg",
        name: "Guy J",
      },
      {
        link: "https://open.spotify.com/artist/5vdjF79d5d2m12FOkJhxHB?si=9432c4cd17ed43cd",
        imgSrc:
          "https://images.sk-static.com/images/media/profile_images/artists/4205871/huge_avatar",
        name: "Jeremy Olander",
      },
      {
        link: "https://open.spotify.com/artist/532SqCIYmJyXEdEiCJLgYG?si=a5215e06d261462a",
        imgSrc:
          "https://pbs.twimg.com/profile_images/1154071122981376001/trUUcJrI_400x400.jpg",
        name: "Cristoph",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/37i9dQZF1EIfwlfJi9BTMY?utm_source=generator",
  },
  {
    name: "Trance",
    bpmRange: "130-150 BPM",
    description:
      "Trance music is known for its energetic and uplifting melodies. It is characterized by a fast tempo, pulsating beats, and a focus on driving rhythms. Trance tracks often include long breakdowns, epic builds, and euphoric climaxes. The genre aims to create a sense of transcendence and emotional connection on the dancefloor.",
    artists: [
      {
        link: "https://open.spotify.com/artist/0SfsnGyD8FpIN4U4WCkBZ5?si=30924a3f216b414f",
        imgSrc:
          "https://i.scdn.co/image/ab6761610000e5eb5328c468cef8019bc41b63a8",
        name: "Armin van Buuren",
      },
      {
        link: "https://open.spotify.com/artist/10gzBoINW3cLJfZUka8Zoe?si=165a4116e27a4032",
        imgSrc:
          "https://taogroup.com/wp-content/uploads/2023/03/230000_TGH_AboveBeyond_2400x2400.jpg",
        name: "Above & Beyond",
      },
      {
        link: "https://open.spotify.com/artist/7wU1naftD3lNq7rNsiDvOR?si=385859d5cab14bd3",
        imgSrc:
          "https://d3vhc53cl8e8km.cloudfront.net/hello-staging/wp-content/uploads/2014/06/11145506/main-972x597.jpg",
        name: "Paul van Dyk",
      },
      {
        link: "https://open.spotify.com/artist/2ohlvFf9PBsDELdRstPtlP?si=9e9b60748bf64a23",
        imgSrc:
          "https://static.wixstatic.com/media/3c84ef_000258033d4240c89e592ac14dc4bb03~mv2.jpg/v1/fill/w_2500,h_2580,al_c/3c84ef_000258033d4240c89e592ac14dc4bb03~mv2.jpg",
        name: "Ferry Corsten",
      },
      {
        link: "https://open.spotify.com/artist/0hprEC0nsWuQPSHag1O2Vi?si=94b52c044aa04399",
        imgSrc:
          "https://yt3.googleusercontent.com/dAKTMmQgkkSDxmp-Oh3MBko3Anuj8P35CgFvibagiFg65H6lWPOly9V4jXKqCaeIMLidj98e_Q=s900-c-k-c0x00ffffff-no-rj",
        name: "Gareth Emery",
      },
      {
        link: "https://open.spotify.com/artist/2hL1EouqXLtBEB6JKnPF0h?si=3837a4bd1f3541ed",
        imgSrc:
          "https://yt3.googleusercontent.com/ytc/AGIKgqNsxjPD5TcYzIvKrmhjhW2yyrocO4xvmP0qIvqFpw=s900-c-k-c0x00ffffff-no-rj",
        name: "Aly & Fila",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/0Q3ugz23LAXFg2PvXJ8hMx?utm_source=generator",
  },

  {
    name: "Techno",
    bpmRange: "130-150 BPM",
    description:
      "Techno is a genre known for its repetitive beats, driving rhythm, and dark and industrial soundscapes. It typically features a fast tempo and emphasizes the use of electronic instruments and synthesizers. Techno tracks often create a hypnotic and immersive experience with its relentless energy and immersive atmosphere.",
    artists: [
      {
        link: "https://open.spotify.com/artist/19SmlbABtI4bXz864MLqOS?si=83ac08ed1f5248ea",
        imgSrc:
          "https://ibiza-style.com/wp-content/uploads/2017/07/Carl-Cox_Ibiza-Style-003.jpg",
        name: "Carl Cox",
      },
      {
        link: "https://open.spotify.com/artist/1btv9qmIpbp7q1ixCYNdHu?si=275647d042b54310",
        imgSrc:
          "https://www.clubbingspain.com/imagenes/Adam-Beyer-2016-600.jpg",
        name: "Adam Beyer",
      },
      {
        link: "https://open.spotify.com/artist/1oZmFNkGAT93yD1xX4vTRE?si=ea710e48dea7457b",
        imgSrc:
          "https://static.ra.co/images/news/2022/nina-kraviz-statement.jpeg",
        name: "Nina Kraviz",
      },
      {
        link: "https://open.spotify.com/artist/5Ho1vKl1Uz8bJlk4vbmvmf?si=a032b940474043b8",
        imgSrc:
          "https://yt3.googleusercontent.com/ytc/AGIKgqNISrYZBgxbqOD2tMl4ne1aEdZwKDrtGHEM5dbV=s900-c-k-c0x00ffffff-no-rj",
        name: "Amelie Lens",
      },
      {
        link: "https://open.spotify.com/artist/1lJhME1ZpzsEa5M0wW6Mso?si=ca9217c1a671479f",
        imgSrc:
          "https://images.sk-static.com/images/media/profile_images/artists/8805714/huge_avatar",
        name: "Charlotte de Witte",
      },
      {
        link: "https://open.spotify.com/artist/3fI3Z6NnYoeSQjcqPQDbM4?si=24b0bef6d83b450a",
        imgSrc:
          "https://res.cloudinary.com/shotgun/image/upload/v1621367134/production/artworks/artists/Len_Faki___Official.jpg",
        name: "Len Faki",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/37i9dQZF1DX6J5NfMJS675?utm_source=generator",
  },
  {
    name: "Drum and Bass",
    bpmRange: "160-180 BPM",
    description:
      "Combines fast-paced breakbeats with heavy basslines, high-energy tempo, intricate rhythms, and complex percussion patterns.",
    artists: [
      {
        link: "https://open.spotify.com/artist/7MqnCTCAX6SsIYYdJCQj9B?si=fa62ca3c1623432c",
        imgSrc:
          "https://www.billboard.com/wp-content/uploads/2020/09/Pendulum-2020-cr-Charlie-Cummings-billboard-1548-1600359169.jpg",
        name: "Pendulum",
      },
      {
        link: "https://open.spotify.com/artist/4YWj8sohRDjL9deiuRvEEY?si=f4a66570e2ea4c76",
        imgSrc:
          "https://i1.sndcdn.com/avatars-PbVE4rnZOwNtPs7R-39BeSw-t500x500.jpg",
        name: "Noisia",
      },
      {
        link: "https://open.spotify.com/artist/0QaSiI5TLA4N7mcsdxShDO?si=d2c165ac37a742c4",
        imgSrc: "https://d23sy9fe9womrt.cloudfront.net/9/38269_lg.jpg",
        name: "Sub Focus",
      },
      {
        link: "https://open.spotify.com/artist/2N8IPNZTiNo3nj4mreOlHU?si=ecac0ed448294768",
        imgSrc:
          "https://i.scdn.co/image/ab6761610000e5eb52a1c9d55b877a4e884f33d0",
        name: "Camo & Krooked",
      },
      {
        link: "https://open.spotify.com/artist/5TgQ66WuWkoQ2xYxaSTnVP?si=c87a24fa173e4438",
        imgSrc:
          "https://i1.sndcdn.com/avatars-7QO5WHHCGzYvDpRc-X8U87g-t500x500.jpg",
        name: "Netsky",
      },
      {
        link: "https://open.spotify.com/artist/1QMgre3BHX161ZHtWMUu6S?si=a86156052d0b42f1",
        imgSrc:
          "https://imgproxy.ra.co/_/quality:66/aHR0cHM6Ly9zdGF0aWMucmEuY28vaW1hZ2VzL25ld3MvMjAxOC9mYWJyaWNsaXZlLTk4LWRpbWVuc2lvbi5qcGc=",
        name: "Dimension",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/0Zarq4BVkFkZOWkmqsfrjA?utm_source=generator",
  },
  {
    name: "Hardcore",
    bpmRange: "160-200 BPM",
    description:
      "Intense and aggressive genre with fast and heavy beats, distorted sounds, high energy, and a relentless tempo.",
    artists: [
      {
        link: "https://open.spotify.com/artist/4sQNUQjOYj9rV2sdfJ8laS?si=b8486629056f4b4f",
        imgSrc:
          "https://i.discogs.com/X3L--pOdUGG9Fkth8Gmhbv6OXiMm_wvIxBFdpF7-ZJw/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTI1OTU4/LTE1NDk4OTY4NjMt/NzYzNS5qcGVn.jpeg",
        name: "Angerfist",
      },
      {
        link: "https://open.spotify.com/artist/7oX7rzli18XsB2WFd88oW4?si=896e4d75874f4b3d",
        imgSrc: "https://d3vhc53cl8e8km.cloudfront.net/artists/2452/main.jpg",
        name: "DJ Mad Dog",
      },
      {
        link: "https://open.spotify.com/artist/0S6b11xqvO6XOWZSukSjiY?si=af06a93ae80e4aae",
        imgSrc:
          "https://i.scdn.co/image/971c87b2eeaaf3829bc146cf830210e8ba3be908",
        name: "Nosferatu",
      },
      {
        link: "https://open.spotify.com/artist/776uRsooWrGiVZkVWtvfgO?si=f926fb7774fc4b20",
        imgSrc: "https://s3.amazonaws.com/bit-photos/large/8575145.jpeg",
        name: "Miss K8",
      },
      {
        link: "https://open.spotify.com/artist/1Yc03TvBp08WN2oHVuvewX?si=ce66611d430e42d7",
        imgSrc:
          "https://www.mastersofhardcore.com/wp-content/uploads/2018/05/20180616_Destructive-Tendencies_Danny-Rossen_120_4691_jasonleespruce_edit_1-e1560333721881-1280x1280.jpg",
        name: "Destructive Tendencies",
      },
      {
        link: "https://open.spotify.com/artist/39cgo5SPJygKIlIcrwkd73?si=a6fac5edde6843ce",
        imgSrc:
          "https://i.discogs.com/C4cZ-6gI23ZuMl41a-ZKE7BmnWXxwNLkIThJBMOYr6I/rs:fit/g:sm/q:90/h:561/w:450/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTE3MTI4/MC0xNTY0ODExOTAx/LTcxODguanBlZw.jpeg",
        name: "Partyraiser",
      },
    ],
    playlist:
      "https://open.spotify.com/playlist/4JX8czVXDcs5dqbMo4xQGR?utm_source=generator",
  },
];

export default electronicMusicSubgenres;
